module.exports = __webpack_public_path__ + "static/PUSH-BNA-Chatbot-Video2_Trim-1811d16f2bc4a6fd011170bceea426c8.mp4";